import styled from "styled-components";

export const SSOLoginStyled = styled.div`
  width: 100%;
  padding: 30px 16px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;